import React, { useEffect } from 'react';
import { HashRouter, Switch, Redirect } from 'react-router-dom';
import { HAS_ROUTE_DEFAULT_ROUTE } from '../../constants/documentList';

export default function HasBasePath({ baseName, children, location, history }: any) {
  /**
   * Has routing has used to chanel EI and Fas.
   *
   * if it's only /md then basepath / otherwise it will append base url
   *
   */

  useEffect(() => {
    let unlisten = history?.listen((location: any) => {
      const { pathname } = location;
      if (HAS_ROUTE_DEFAULT_ROUTE.includes(pathname))
        history.push(`${pathname}/md/my-documents`);
    });

    return () => {
      unlisten && unlisten();
    };
  }, []);

  if (baseName) {
    return (
      <HashRouter basename={baseName === '/md' ? '/' : baseName}>
        <Switch>{children}</Switch>
        {HAS_ROUTE_DEFAULT_ROUTE.includes(location?.pathname) && (
            <Redirect to="/md/my-documents" />
          )}
      </HashRouter>
    );
  }
  return <Switch>{children}</Switch>;
}
